import styled from 'styled-components';

export const GenericWrapper = styled.div`
  color: ${(props) => props.theme.colors.blue};
`;

export const GenericContent = styled.div``;
